import type { NearbyVisibilityScope } from '@hooks'

export type NearbyVisibilityState = 'LOADING' | 'UNKNOWN' | 'ALL' | NearbyVisibilityScope

/**
 * What the visibility sentence must say. The server answers `scope: null` for
 * "visible to everyone" (the default): an empty scope is a real answer, not a
 * request still in flight. A failed read is neither: it must not be shown as a
 * visibility the person did not choose.
 */
export const getNearbyVisibilityState = (
  isLoading: boolean,
  isError: boolean,
  scope: NearbyVisibilityScope | null | undefined,
): NearbyVisibilityState => {
  if (isLoading) return 'LOADING'
  if (isError) return 'UNKNOWN'
  return scope ?? 'ALL'
}
